module.exports = __webpack_public_path__ + "img/pchomemap.12ca3254.svg";